import { render, staticRenderFns } from "./PricingStigg.vue?vue&type=template&id=88ae5732&"
import script from "./PricingStigg.vue?vue&type=script&lang=js&"
export * from "./PricingStigg.vue?vue&type=script&lang=js&"
import style0 from "./PricingStigg.vue?vue&type=style&index=0&id=88ae5732&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports